import { render, staticRenderFns } from "./IrReports.vue?vue&type=template&id=252bb816&"
import script from "./IrReports.vue?vue&type=script&lang=js&"
export * from "./IrReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports